/* tslint:disable */

declare var Object: any;
export interface BitlyServiceInterface {
  "id"?: number;
}

export class BitlyService implements BitlyServiceInterface {
  "id": number;
  constructor(data?: BitlyServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `BitlyService`.
   */
  public static getModelName() {
    return "BitlyService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of BitlyService for dynamic purposes.
  **/
  public static factory(data: BitlyServiceInterface): BitlyService{
    return new BitlyService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'BitlyService',
      plural: 'BitlyServices',
      path: 'BitlyServices',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
